import { handleError } from "../../../util/errors";
import apiBase from "../../api";
import { UPLOAD_CERTIFICATE, UPLOAD_CERTIFICATE_PACKAGE, FETCH_CERTIFICATES, DELETE_CERTIFICATE } from "../../urls";

class CertificateService {
  uploadCertificate = async (certificate, pac, password) => {
    try {
      const formData = new FormData();
      formData.append("certificate", certificate);
      formData.append("pac", pac);
      formData.append("password", password);
      
      const response = await apiBase.post(UPLOAD_CERTIFICATE, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      
      return response;
    } catch (error) {
      handleError(error);
      throw error;
    }
  };

  uploadCertificatePackage = async (files) => {
    try {
      const formData = new FormData();
      files.forEach((file) => formData.append("files", file));

      const response = await apiBase.post(UPLOAD_CERTIFICATE_PACKAGE, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      return response.data;
    } catch (error) {
      handleError(error);
      throw error;
    }
  };

  getCertificates = async (page = 1, perPage = 10, term = "", sortBy = "id", order = "DESC") => {
    try {
      const response = await apiBase.get(
        FETCH_CERTIFICATES(page, perPage, term, sortBy, order)
      );
      return response.data;
    } catch (error) {
      handleError(error);
      throw error;
    }
  };

  deleteCertificate = async (id) => {
    try {
      const response = await apiBase.delete(DELETE_CERTIFICATE(id));
      return response.data;
    } catch (error) {
      handleError(error);
      throw error;
    }
  };
}

export default new CertificateService(); 